module.exports = __webpack_public_path__ + "img/set_100.e5483792.png";